import React from "react";
import PropTypes from "prop-types";
import { useWeb3React } from "@web3-react/core";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { prepareWalletSiwe, walletSiwe } from "@bkry/bowline-redux/wallets";
import { getProjectAttributes } from "@bkry/bowline-redux/projects";
import { getEnv } from "@bkry/bowline-utils";

const SignInWithEthereumButton = (props, context) => {
  const REACT_APP_PROJECT_ID = getEnv("REACT_APP_PROJECT_ID");
  const { className, label, color, size, block, outline, onSuccess } = props;
  const { account, provider, connector } = useWeb3React();
  const dispatch = useDispatch();

  const projectData = useSelector((state) =>
    getProjectAttributes(state, REACT_APP_PROJECT_ID)
  );

  const networkToChainId = {
    ethereum: "1",
    ropsten: "3",
    rinkeby: "4",
    goerli: "5",
    kovan: "42",
    sepolia: "11155111",
    polygon: "137",
    mumbai: "80001",
    lukso: "100",
    lukso_testnet: "1007",
    amoy: "80002",
  };

  const chainId = networkToChainId?.[projectData?.default_network];

  const handleClick = () => {
    dispatch(
      prepareWalletSiwe({
        provider,
        connector,
        chainId,
        account,
        callbackSuccess: ({ nonce, nonceIssuedAt }) => {
          dispatch(
            walletSiwe({
              account,
              nonce,
              nonceIssuedAt,
              provider:
                connector?.loginProvider ||
                provider?.connection?.url ||
                "Unknown",
              chainId,
              callbackSuccess: () => {
                onSuccess ? onSuccess() : null;
              },
            })
          );
        },
      })
    );
  };

  return (
    <Button
      onClick={handleClick}
      className={className}
      color={color}
      size={size}
      block={block}
      outline={outline}
    >
      {label ? label : context.t("Sign in with Wallet")}
    </Button>
  );
};

/**  define proptype for the 'translation' function  */
SignInWithEthereumButton.contextTypes = {
  t: PropTypes.func,
};

SignInWithEthereumButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  block: PropTypes.bool,
  outline: PropTypes.bool,
  onSuccess: PropTypes.func,
};

SignInWithEthereumButton.defaultProps = {
  color: "secondary",
  size: "md",
  block: false,
  outline: false,
};

export default SignInWithEthereumButton;
